import React, { useEffect, useRef, useState } from 'react';
import { Upload } from 'lucide-react';

import { Cookies } from 'react-cookie';
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { AlertBox } from '../Common/Input';
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, readFile } from '../Common/ExportData';
import { ImportButton } from '../Common/Common';
import MyProgressBar from '../Common/Progress';
const cookies = new Cookies();
const ImportStockReconciliation = ({ open, setOpen }) => {

    const inputrefs = useRef([]);

    const [SubLoad, setSubLoad] = useState(false);
    const [Status, setStatus] = useState([]);
    const [Name, setName] = useState('');
    const [ImportData, setImportData] = useState([]);
    const [formData, setFormData] = useState({ isUpdate: false });

    const [progress, setProgress] = useState({
        total: 0,
        processed: 0,
        successCount: 0,
        errorCount: 0
    });

    let percentage = (progress.processed / progress.total) * 100 || 0;
    percentage = percentage.toFixed(0);

    const DownloadFormat = async () => {
        await DownloadFileAtURL('ImportStockReconciliation.xlsx');
    };

    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'ImportBulkStatusError');
    };

    const BulkSubmit = async (e) => {
        let data = await readFile(e);
        setImportData(data.exceljson);
        setName(data.FileName);

        let a = document.querySelectorAll('.bulk-upload');
        if (a.length > 0) {
            a[0].childNodes[2].innerHTML = data.FileName;
        }
    };

    const handleBulk = async () => {

        if (ImportData.length === 0) {
            AlertBox('ERROR', 'Please Choose File With Valid Data!');
            return;
        }

        const insertHeaders = [
            "ItemNo", "CW", "VSE01", "VSE02","VSE03", "VSE04", "VSE05", "VSE06","VSE07", "VSE08", "VSE09", "VSE10", "VSE11"];

        if (!insertHeaders.every(header => Object.keys(ImportData[0]).includes(header))) {
            AlertBox('ERROR', 'Header Format is not valid!');
            BulkClearData(setName);
            return;
        }
        let Token = cookies.get('token');
        const LoginUserCode = await cookies.get('loginUserCode');
        setSubLoad(true);

        let data = {
            Token: Token,
            LoginUserCode: LoginUserCode?.toString(), 
            ImportData
        };

        post(`${API_SERVER}/api/Operation/InsertStockReconsilation`, data, (res) => {

            if (res.status === "SUCCESS") {
                setStatus({
                    SuccessCount: res.SuccessCount || 0,
                    ErrorCount: res.ErrorCount || 0,
                    ErrorData: res.ErrorData || []
                });

                AlertBox('SUCCESS', res.message || "Uploaded Successfully");
                BulkClearData(setName);
            }
            else if (res.message === "EXPIRED") {
                window.location.href = '/Login';
            }
            else {
                AlertBox('ERROR', res.message);
            }

            setSubLoad(false);
        });
    };

    useEffect(() => {
        document.title = 'Import Stock Reconciliation';
    }, []);

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>

            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">

                        <div className="content-box">

                            {/* Heading */}
                            <div className="heading-box">
                                <div className="heading d-flex align-items-center gap-2">
                                    <Upload size={20} className="text-primary" />
                                    <h6 className="m-0 font-weight-bold text-primary">
                                        Import Stock Reconciliation
                                    </h6>
                                </div>
                            </div>

                            {/* FORM AREA (same pattern as Stock page) */}
                            <div className="form-box service-content-area">

                                <div className="row">

                                    {/* LEFT SIDE */}
                                    <div className="col-lg-6 col-md-6 col-sm-12">

                                        <div className="card p-3 shadow-sm mb-3">

                                            <h6 className="text-dark mb-2">Notes</h6>
                                            <ul className="small text-muted ps-3">
                                                <li>Upload only <b>.xlsx</b> file</li>
                                                <li>Header must match format</li>
                                                <li>Max records: <b>100000</b></li>
                                            </ul>
                                        </div>

                                        <textarea
                                            className="form-control bg-light small"
                                            rows={5}
                                            value=" ItemNo, CW, VSE01, VSE02, VSE03, VSE04, VSE05, VSE06, VSE07, VSE08, VSE09, SE10, VSE11"
                                            readOnly
                                            disabled
                                        />

                                    </div>

                                    {/* RIGHT SIDE */}
                                    <div className="col-lg-6 col-md-6 col-sm-12">

                                        <div
                                            className="border border-2 border-primary rounded p-4 text-center upload-handler "

                                        >
                                            <ImportButton
                                                handleBulk={handleBulk}
                                                BulkSubmit={(e) => BulkSubmit(e)}
                                                downloadFormat={DownloadFormat}
                                                ErrorData={ErrorData}
                                                Status={Status}
                                                fileName={Name}
                                                formData={formData}
                                                setFormData={setFormData}
                                                isUpdateBulk={true}
                                            />
                                        </div>
                                        <div className="lms-new-button text-end mb-4">

                                            {/*<button*/}
                                            {/*    className="button save-btn me-2"*/}
                                            {/*    onClick={handleBulk}*/}
                                            {/*>*/}
                                            {/*    <i className="bi bi-upload"></i> Upload*/}
                                            {/*</button>*/}

                                            <button
                                                className="button reset-btn"
                                                onClick={() => {
                                                    setSubLoad(false);
                                                    setStatus([]);
                                                    setName('');
                                                    setImportData([]);
                                                }}
                                            >
                                                <i className="bi bi-arrow-clockwise"></i> Reset
                                            </button>

                                        </div>
                                    </div>

                                </div>

                                {/* BUTTONS (same style as stock page) */}
                                {/*<div className="lms-new-button text-center mt-4">*/}

                                {/*    <button*/}
                                {/*        className="button save-btn me-2"*/}
                                {/*        onClick={handleBulk}*/}
                                {/*    >*/}
                                {/*        <i className="bi bi-upload"></i> Upload*/}
                                {/*    </button>*/}

                                {/*    <button*/}
                                {/*        className="button reset-btn"*/}
                                {/*        onClick={() => {*/}
                                {/*            setSubLoad(false);*/}
                                {/*            setStatus([]);*/}
                                {/*            setName('');*/}
                                {/*            setImportData([]);*/}
                                {/*        }}*/}
                                {/*    >*/}
                                {/*        <i className="bi bi-arrow-clockwise"></i> Reset*/}
                                {/*    </button>*/}

                                {/*</div>*/}

                            </div>

                        </div>

                    </div>
                </div>
            </section>

            {/* PROGRESS BAR */}
            {SubLoad && (
                <MyProgressBar percentage={percentage} progress={progress} />
            )}

        </main>
    );
};

export default ImportStockReconciliation;